namespace Matrix.Data {
    export namespace TestGroupService {
        export const baseUrl = 'Data/TestGroup';

        export declare function Create(request: Serenity.SaveRequest<TestGroupRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TestGroupRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TestGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TestGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Run(request: Data.Repositories.TestGroupRunRequest, onSuccess?: (response: Data.Repositories.TestGroupRunResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/TestGroup/Create",
            Update = "Data/TestGroup/Update",
            Delete = "Data/TestGroup/Delete",
            Retrieve = "Data/TestGroup/Retrieve",
            List = "Data/TestGroup/List",
            Run = "Data/TestGroup/Run"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Run'
        ].forEach(x => {
            (<any>TestGroupService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
